{
  "version": 1,
  "asset_id": "0552c305-3293-4c85-8fe7-3d8107028676",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/0552c305-3293-4c85-8fe7-3d8107028676/avogreek.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/0552c305-3293-4c85-8fe7-3d8107028676/avogreek.webp",
  "original_filename": "avogreek.webp",
  "size": 143744,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:02:50Z"
}
